import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" })
});
export default SvgList;
